import React, { useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import ls from "../../../../common/helpers/localStorageActions";

function TrackMessage({ message }) {
  const { msgId, msg, expDate } = message;
  const now = new Date().getTime();
  const expTime = new Date(expDate).getTime();

  const seenMessages = useMemo(() => ls.getPulsarTrackSeenMessages() || {}, []);
  const shouldShow = now < expTime && !seenMessages[msgId];
  const [isVisible, setIsVisible] = useState(shouldShow);

  const handleOnClose = useCallback(() => {
    const timeNow = new Date().getTime();
    const storedMessages = ls.getPulsarTrackSeenMessages() || {};
    const msgArr = Object.entries(storedMessages);
    const datedArr = msgArr.map((x) => [x[0], new Date(x[1]).getTime()]);
    const filtered = datedArr.filter((x) => x[1] > timeNow);
    const newMessages = Object.fromEntries(filtered);
    const updatedNew = { ...newMessages, [msgId]: expTime };
    ls.setPulsarTrackSeenMessages(updatedNew);
    setIsVisible(false);
  }, []);

  return message && isVisible ? (
    <div className="tw-text-base tw-color-blueGray-700">
      <div className="tw-bg-blueGray-400 tw-bg-opacity-20 tw-absolute tw-inset-0 tw-flex tw-justify-center tw-items-center">
        <div className="tw-bg-blueGray-200 tw-shadow-2xl tw-bg-opacity-60 tw-px-8 tw-py-6 backdrop-filter-blur-md tw-rounded-lg tw-w-96">
          {msg}
          <i
            onClick={handleOnClose}
            className="fa fa-times tw-absolute tw-top-2 tw-right-2 tw-cursor-pointer"
          />
        </div>
      </div>
    </div>
  ) : null;
}

TrackMessage.propTypes = {
  message: PropTypes.shape({
    msg: PropTypes.string,
    expDate: PropTypes.string,
    msgId: PropTypes.string,
  }).isRequired,
};

export default TrackMessage;
